export default __webpack_public_path__ + "static/media/pt-logo-header.c816466c.svg";